import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/Search/SearchPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Search/redial';
import {ConditionalSearchTermRedirect} from '@aboutyou/logic-components';
import {
  Redirect,
  useParams,
  usePathname,
  useSearch,
  useSearchRoute,
} from '@aboutyou/router';
import {useSearchEventsUtils, useTrackSearch} from '@aboutyou/tracking';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);
const SearchResultPage = withLegacyProviders(PageWithRedial);

export const SearchResultsPage = () => {
  const params = useParams<{term?: string}>();
  const searchRoute = useSearchRoute();
  const {resetEventContextParams, searchEventContextParams} =
    useSearchEventsUtils();
  const trackSearch = useTrackSearch();
  const search = useSearch();
  const pathname = usePathname();

  if (params.term) {
    return <Redirect to={`${searchRoute}?term=${params.term}`} />;
  }

  return (
    <>
      <ConditionalSearchTermRedirect />
      <SearchResultPage
        shouldTrackSearch={() => {
          if (searchEventContextParams && searchEventContextParams.shouldFire) {
            trackSearch({
              searchAction: 'submit',
              searchType: 'srp',
              searchTerm: searchEventContextParams.searchTerm,
              searchName: searchEventContextParams.searchName,
              searchDestination: pathname + search,
              searchTermCompleted:
                searchEventContextParams.searchTermCompleted ?? '',
            });
            resetEventContextParams();
          }
        }}
      />
    </>
  );
};
